export default "__VITE_ASSET__BRP6sRyD__"